import React, { PureComponent, Fragment } from 'react'
import styles from './Success.scss'
import animated from './animate.css'
import CountUp from 'react-countup'
import { Waypoint } from 'react-waypoint'
import { Element } from 'react-scroll'

export default class Success extends PureComponent {
  _onClickQuestion = () => {
    this.props.ourResourceEl.setState({
      isVisibleOurResource: true,
    })
  }

  checkEnterList = []
  checkEnter = (name, start = null) => () => {
    if (this.checkEnterList.indexOf(name) == -1) {
      this.checkEnterList.push(name)
      if (start) start()
    }
  }
  renderCountUp = (name, num) => (
    <CountUp className="countup" separator="," start={0} end={num}>
      {({ countUpRef, start }) => (
        <Fragment>
          <span ref={countUpRef} />
          <em style={{ color: 'inherit', fontSize: '12px', position: 'absolute', top: '0' }}>+</em>
          <Waypoint onEnter={this.checkEnter(name, start)} />
        </Fragment>
      )}
    </CountUp>
  )
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <style jsx>{animated}</style>
        <Element name="success" />
        <div className="success">
          <h2>累積成就</h2>
          <div className="box-wrap">
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/successArticles.png" />
              </div>
              <div className="text">
                <p>每月發佈文章數</p>
                <p className="number">{this.renderCountUp('success1', 13000)}</p>
              </div>
            </div>
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/successBrowse.png" />
              </div>
              <div className="text">
                <p>每月文章累積瀏覽</p>
                <p className="number">{this.renderCountUp('success2', 10000000)}</p>
              </div>
            </div>
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/successBrand.png" />
              </div>
              <div className="text">
                <p>合作品牌數</p>
                <p className="number">{this.renderCountUp('success3', 100)}</p>
              </div>
            </div>
            <div className="box">
              <div className="img">
                <img src="/statics/images/creator/landingPage/successFans.png" />
              </div>
              <div className="text">
                <p>社群媒體總粉絲數</p>
                <img
                  src="/statics/images/creator/landingPage/question.png"
                  onClick={this._onClickQuestion}
                />
                <p className="number">{this.renderCountUp('success4', 7200000)}</p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
